import { render } from "./TipiSicurezza.vue?vue&type=template&id=d29dac10"
import script from "./TipiSicurezza.vue?vue&type=script&lang=js"
export * from "./TipiSicurezza.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__